import { useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface ApiKeyFieldProps {
  value: string;
  configured: boolean;
  disabled: boolean;
  onChange: (value: string) => void;
}

export function ApiKeyField({
  value,
  configured,
  disabled,
  onChange,
}: ApiKeyFieldProps) {
  const [showKey, setShowKey] = useState(false);

  const toggleShowKey = () => {
    setShowKey((prev) => !prev);
  };

  return (
    <TextField
      label="API-ключ Нової пошти"
      type={showKey ? 'text' : 'password'}
      fullWidth
      variant="outlined"
      margin="normal"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={configured ? 'Ключ уже налаштовано' : 'Вставте API-ключ з бізнес-кабінету Нової пошти'}
      helperText={configured
        ? 'Поле порожнє при збереженні = ключ лишається без змін'
        : 'Обовʼязково при першому налаштуванні'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={toggleShowKey} edge="end">
              {showKey ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
